import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TextInputComponent} from './text-input/text-input.component';
import {CommonModule} from '@angular/common';
import {NumberInputComponent} from './number-input/number-input.component';
import {TextareaComponent} from './textarea/textarea.component';
import {RichTextComponent} from './richtext/richtext.component';
import {AutoresizeDirective} from './_directives/autoresize.directive';
import {SelectComponent} from './select/select.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {CheckboxComponent} from './checkbox/checkbox.component';
import {ButtonCheckboxComponent} from './buttons/button-checkbox/button-checkbox.component';
import {
	NgbDatepickerModule,
	NgbPopoverModule,
	NgbTimepickerModule,
	NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import {CheckboxListComponent} from './checkbox-list/checkbox-list.component';
import {FileComponent} from './file/file.component';
import {FileUploadModule} from 'shared/lib/file-upload/file-upload.module';
import {DateInputComponent} from './date/date-input.component';
import {TimepickerComponent} from './timepicker/timepicker.component';
import {RadioComponent} from './radio/radio.component';
import {RadioListComponent} from './radio-list/radio-list.component';
import {TRANSLOCO_SCOPE, TranslocoModule} from '@ngneat/transloco';
import {ButtonRadioComponent} from './buttons/button-radio/button-radio.component';
import {DateRangePickerComponent} from './date-range-picker/date-range-picker.component';
import { SwitchComponent } from './switch/switch.component';
import {SharedModule} from 'shared/lib/shared.module';
import {PhrasesSelectComponentModule} from './phrases-select/phrases-select.component';
import {QuillModule} from 'ngx-quill';
import {SelectableWithOtherComponent} from './selectable-with-other/selectable-with-other.component';
import { FormControlSanitizerPipe } from './_pipes/form-control-sanitizer.pipe';
import {NgDompurifyModule} from '@tinkoff/ng-dompurify';

@NgModule({
	declarations: [
		TextInputComponent,
		NumberInputComponent,
		TextareaComponent,
		RichTextComponent,
		AutoresizeDirective,
		SelectComponent,
		CheckboxComponent,
		ButtonCheckboxComponent,
		FileComponent,
		CheckboxListComponent,
		DateInputComponent,
		TimepickerComponent,
		TimepickerComponent,
		RadioComponent,
		RadioListComponent,
		ButtonRadioComponent,
		DateRangePickerComponent,
		SwitchComponent,
		SelectableWithOtherComponent,
		FormControlSanitizerPipe
	],
	imports: [
		ReactiveFormsModule,
		FormsModule,
		CommonModule,
		TranslocoModule,
		QuillModule,
		NgSelectModule,
		FileUploadModule,
		NgbDatepickerModule,
		NgbTimepickerModule,
		SharedModule,
		NgbPopoverModule,
		NgbTooltipModule,
		PhrasesSelectComponentModule,
		QuillModule,
		NgDompurifyModule
	],
	providers: [{provide: TRANSLOCO_SCOPE, useValue: 'formElements', multi: true}],
	exports: [
		TextInputComponent,
		NumberInputComponent,
		TextareaComponent,
		RichTextComponent,
		AutoresizeDirective,
		SelectComponent,
		CheckboxComponent,
		RadioComponent,
		ButtonCheckboxComponent,
		FileComponent,
		CheckboxListComponent,
		DateInputComponent,
		RadioListComponent,
		TimepickerComponent,
		ButtonRadioComponent,
		DateRangePickerComponent,
		SwitchComponent,
		SelectableWithOtherComponent,
		FormControlSanitizerPipe
	]
})
export class FormElementsModule {
}
